import type { SystemEvent } from '@weft/types';
import { SYSTEM_EVENT_TYPES } from '@weft/types';
import { raiseUnreachable } from '@weft/utils';

export function getSystemEventLabel(systemEvent: SystemEvent): string {
  switch (systemEvent.type) {
    case SYSTEM_EVENT_TYPES.INVOICE_CREATED:
      return 'Created';
    case SYSTEM_EVENT_TYPES.INVOICE_APPROVED:
      return 'Approved';
    case SYSTEM_EVENT_TYPES.INVOICE_PAID:
      return 'Paid';
    default:
      return raiseUnreachable(systemEvent.type);
  }
}